import { STATSIG_EXPERIMENTS } from '../../config/statsig-experiments.config'

import { useStatsigInitContext } from './statsig.context'

/**
 *
 * @param experimentKey
 * @deprecated use useStatsigExperiment instead
 */
export function useStatsigExperimentBucket(experimentKey: STATSIG_EXPERIMENTS | null) {
  const { getExperimentBucket } = useStatsigInitContext()

  if (!experimentKey) return null

  const experimentBucket = getExperimentBucket(experimentKey)
  return experimentBucket
}

export function useStatsigExperiment(experimentKey: STATSIG_EXPERIMENTS | null, shouldFetchExperiment = true) {
  const { getExperimentBucket, init } = useStatsigInitContext()

  if (!experimentKey || !shouldFetchExperiment) return { experimentBucket: null, init }

  const experimentBucket = getExperimentBucket(experimentKey)
  return { experimentBucket, init }
}
